import { render, staticRenderFns } from "./shugang.vue?vue&type=template&id=5c86b886&scoped=true&"
import script from "./shugang.vue?vue&type=script&lang=js&"
export * from "./shugang.vue?vue&type=script&lang=js&"
import style0 from "@/assets/components.scss?vue&type=style&index=0&id=5c86b886&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c86b886",
  null
  
)

export default component.exports